import { render, staticRenderFns } from "./activar_desactivar_fromulario.vue?vue&type=template&id=aab2fccc"
import script from "./activar_desactivar_fromulario.vue?vue&type=script&lang=js"
export * from "./activar_desactivar_fromulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports